import React, { ComponentProps } from 'react';
import { Icon, Text, Tooltip, useIsMobile } from '@amzn/storm-ui';
import { spinner as spinnerIcon } from '@amzn/storm-ui-icons';
import AdaptiveHelpTip from '@amzn/storm-ui-adaptive-helptip';
import { Button, SpinnerWrap, TextButton } from './styles';
import { ACTION_STATE, BUTTON_TYPE, ButtonType } from '../types';
import { FlexContainer } from 'src/commons/components/FlexContainer';

export const ActionsButton: React.VFC<ButtonType> = ({
  buttonType,
  state,
  id,
  label,
  toolTip,
  tooltipPosition,
  ariaLabel,
  onClickEvent,
}) => {
  const isDisabled = state === ACTION_STATE.DISABLED;
  const isLoading = state === ACTION_STATE.LOADING;
  const isMobile = useIsMobile() ?? false;

  const spinner = isLoading && (
    <SpinnerWrap>
      <Icon type={spinnerIcon} />
    </SpinnerWrap>
  );

  let button;
  const commonButtonProps: ComponentProps<typeof TextButton> = {
    id,
    'data-eventid': id,
    'data-ccx-e2e-id': `aac-button-${id}`,
    onClick: onClickEvent,
    'aria-label': ariaLabel,
    disabled: isLoading || isDisabled,
    style: isDisabled ? { pointerEvents: 'none' } : undefined,
    'aria-haspopup': toolTip && toolTip.length > 0 ? 'true' : undefined,
  };

  if (buttonType === BUTTON_TYPE.LINK) {
    button = (
      <TextButton {...commonButtonProps}>
        {spinner}
        {label}
      </TextButton>
    );
  } else if (isDisabled) {
    // need to wrap disabled button in div for tooltip to work
    button = (
      <div>
        <Button
          {...commonButtonProps}
          primary={buttonType === BUTTON_TYPE.PRIMARY}
          disabled={true}
          style={{ pointerEvents: 'none' }}
        >
          {spinner}
          {label}
        </Button>
      </div>
    );
  } else {
    button = (
      <Button
        {...commonButtonProps}
        primary={buttonType === BUTTON_TYPE.PRIMARY}
      >
        {spinner}
        {label}
      </Button>
    );
  }

  return (
    <FlexContainer alignItems="center" justifyContent="center">
      {toolTip?.length ? (
        <>
          {isMobile ? (
            <>
              {button}
              <AdaptiveHelpTip>
                <Text>{toolTip}</Text>
              </AdaptiveHelpTip>
            </>
          ) : (
            <Tooltip
              nonInteractive
              position={tooltipPosition}
              trigger={button}
              type={isDisabled ? 'dark' : 'light'}
              inert={isMobile}
            >
              <Text>{toolTip}</Text>
            </Tooltip>
          )}
        </>
      ) : (
        button
      )}
    </FlexContainer>
  );
};
